import React, { Component } from 'react';
import {
    Button, Col, Row, Card, CardBody, Form,
    FormGroup, Label, Input, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { Link } from "react-router-dom";
import fileSaver from 'file-saver';
import './style.scss';
import AuthService from '../../../components/Services/AuthService';
import withAuth from '../../../components/Services/WithAuth';
import { connect } from 'react-redux';
import { downloadRiskfactorTemplate, uploadRiskfactorTemplate } from './action';
import Modal from '../../../components/UI/Modal/Modal';
import MyAutosuggest from '../../../components/ReusableComponents/AutoSuggest/index';
class SearchRiskFactorComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRiskType: '',
            selectedOption: null,
            value: '',
            suggestions: [],
            body: null,
            showModal: false,
        };
        this.Auth = new AuthService();
    }
    close = () => {
        this.setState({ showModal: !this.state.showModal })
    }
    componentDidUpdate(prevProps) {
        const { riskFactorDownloadTemplate, riskFactorUploadTemplate, riskFactorTemplateError } = this.props
        if (riskFactorDownloadTemplate !== prevProps.riskFactorDownloadTemplate) {
            let blob = new Blob([riskFactorDownloadTemplate.data], { type: "application/octet-stream" })
            fileSaver.saveAs(blob, '_template.xlsx');
        } else if (riskFactorUploadTemplate !== prevProps.riskFactorUploadTemplate) {
            this.setState({
                showModal: !this.state.showModal,
                body: <div>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{riskFactorUploadTemplate.message}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                    </ModalFooter>
                </div>
            })
        } else if (riskFactorTemplateError !== prevProps.riskFactorTemplateError) {
            if (riskFactorTemplateError.response.status === 401) {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;Authorization Error</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="info" onClick={this.handleLogout}> <Link className="py-3 d-inline-block" onClick={this.handleLogout} to="/">Logout</Link></Button>
                        </ModalFooter>
                    </div>
                })
            } else {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader toggle={this.toggle}>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{(riskFactorTemplateError.response && riskFactorTemplateError.response.data) ? riskFactorTemplateError.response.data.message : "Something went wrong! Please try again."}</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.close}>Close</Button>
                        </ModalFooter>
                    </div>
                })
            }
        }
    }
    handleLogout = () => {
        this.Auth.logout();
        this.props.navigationCallback(false);
    }
    handleRiskTypeChange = (event) => {
        event.preventDefault();
        this.setState({
            selectedOption: '',
            selectedRiskType: event.target.value,
        })
    }
    handleView = (event) => {
        event.preventDefault();
        this.props.history.push("/riskfactor/view/" + this.state.selectedOption.id);
    }
    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
    }
    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };
    handleAuthorization = () => {
        this.Auth.logout();
        this.props.history.push('../../login');
    }
    downloadExcel = () => {
        const id = '';
        this.props.downloadRiskfactorTemplate(id);
    }
    uploadExcel = (event) => {
        event.preventDefault();
        this.props.uploadRiskfactorTemplate(event.target.files[0]);
    }
    searchCallback = (data) => {
        if (data.length === 0) {
            this.setState({
                selectedOption: ''
            })
        } else {
            this.setState({
                selectedOption: data
            })
        }
    }
    render() {
        const { value } = this.state;
        let inputProps = {
            placeholder: "Start typing risk factor name...",
            value,
            onChange: this.onChange,
            disabled: true,
            className: "form-control"
        };
        if (this.state.selectedRiskType) {
            inputProps.disabled = false;
        } else {
            inputProps.disabled = true;
        }
        return (
            <Col>

                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                Search Risk Factor
                            </h4>
                            <Button color="primary" title="Create Risk Factor" tag={Link} to="/riskfactor/create">Create Risk Factor</Button>
                        </div>
                        <Card>
                            <CardBody>
                                <Form className="w-70">
                                    <FormGroup>
                                        <Label for="risk-type">Risk Type</Label>
                                        <Row>
                                            <Col xs="20">
                                                <Input className="form-control-select" type="select" name="select" id="risk-type" onChange={this.handleRiskTypeChange}>
                                                    <option value="">Select</option>
                                                    <option value="qualitative">Qualitative</option>
                                                    <option value="quantitative">Quantitative</option>
                                                    {/* <option value="overridden">Overriden</option> */}
                                                </Input>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="riskTypeSelect">Search</Label>
                                        <Row>
                                            <Col xs="20" disabled={!this.state.selectedRiskType}>
                                                <MyAutosuggest
                                                    id={this.state.selectedRiskType}
                                                    placeholder="Search Risk Factors"
                                                    onChange={this.handleNonFinancialChange}
                                                    searchCallback={this.searchCallback}
                                                    inputProps={inputProps}
                                                    searchType="riskFactorSearch"
                                                />
                                            </Col>
                                            <Col xs="4" className="pl-0">
                                                <Button className="pl-0" color="link" onClick={this.handleView} disabled={!this.state.selectedOption}>View Details</Button>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal show={this.state.showModal} modalClosed={this.close} >
                    {/* {/ <p>Show Modal Data</p > /} */}
                    {this.state.body}
                </Modal>
            </Col>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    riskFactorDownloadTemplate: state.riskFactor.donwloadTemplateSuccess,
    riskFactorUploadTemplate: state.riskFactor.uploadTemplateSuccess,
    riskFactorTemplateError: state.riskFactor.uploadTemplateFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    downloadRiskfactorTemplate: (id) => { dispatch(downloadRiskfactorTemplate(id)) },
    uploadRiskfactorTemplate: (file) => { dispatch(uploadRiskfactorTemplate(file)) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(SearchRiskFactorComponent));
// export default withAuth(SearchRiskFactorComponent);
